import { useGetTrialInfo } from '@/lib/react-query'
import { TrialInfo } from '@/lib/knots-api'
import { differenceInCalendarDays } from 'date-fns/differenceInCalendarDays'

export const ModuleName = 'studio_basic'
export enum TrialStatus {
  Valid,
  ExpireSoon,
  Expired,
}

const getTrialStatus = (trialInfo: TrialInfo): TrialStatus => {
  const isTrialInfoValid = trialInfo.isInfoComplete || !trialInfo.trialEnd
  if (isTrialInfoValid) return TrialStatus.Valid

  const end = new Date(trialInfo.trialEnd!)
  const now = new Date()

  const differenceInDays = differenceInCalendarDays(end, now)

  if (differenceInDays <= 0) {
    return TrialStatus.Expired
  }

  if (differenceInDays < 3) {
    return TrialStatus.ExpireSoon
  }

  return TrialStatus.Valid
}

/**
 * Hook for getting info about trial to show, or hide TrialSection
 * @returns {[Date, TrialStatus]} End date and status of the trial
 */
export const useTrial = (): [Date, TrialStatus] => {
  const { data: trialInfo } = useGetTrialInfo(ModuleName)
  const endDate = trialInfo?.trialEnd ? new Date(trialInfo.trialEnd) : new Date()
  const status = getTrialStatus(trialInfo!)

  return [endDate, status]
}
